import { Icon } from 'gu-ui-kit'
import React from 'react'
import { ROUTES } from 'constants/routes'
import { authorizedRoutes as authR, unAuthorizedRoutes as unAuthR } from '../common/router'
import mergeArraysByKey from 'utils/mergeArraysByKey'

import AccountsMarketplace from 'modules/AccountsMarketplace/Categories'
import AccountsMarketplaceCategory from 'modules/AccountsMarketplace/Category'
import AccountsMarketplaceProducts from 'modules/AccountsMarketplace/Products'
import AccountsMarketplaceProduct from 'modules/AccountsMarketplace/Product'

const unAuthorizedRoutes = []

const authorizedRoutes = [
  {
    exact: true,
    path: ROUTES.ACCOUNTS_MARKETPLACE,
    key: 'accounts-marketplace/list',
    label_key: 'accounts::navigation.marketplace',
    component: AccountsMarketplace,
    icon: <Icon name="user-add" size="m" />,
  },
  {
    path: ROUTES.ACCOUNTS_MARKETPLACE_CATEGORY,
    exact: true,
    key: 'accounts-marketplace/category',
    label_key: 'accounts::navigation.marketplace-category',
    component: AccountsMarketplaceCategory,
    icon: <Icon name="user-add" size="m" />,
  },
  {
    path: ROUTES.ACCOUNTS_MARKETPLACE_CATEGORY_PRODUCTS,
    exact: true,
    key: 'accounts-marketplace/category-products',
    label_key: 'accounts::navigation.marketplace-category-products',
    component: AccountsMarketplaceProducts,
    icon: <Icon name="user-add" size="m" />,
  },
  {
    path: ROUTES.ACCOUNTS_MARKETPLACE_PRODUCT,
    exact: true,
    key: 'accounts-marketplace/product',
    label_key: 'accounts::navigation.marketplace-category-product',
    component: AccountsMarketplaceProduct,
    icon: <Icon name="user-add" size="m" />,
  },
]

const mergedUnAuth = mergeArraysByKey(unAuthR, unAuthorizedRoutes, 'key')
const mergedAuth = mergeArraysByKey(authR, authorizedRoutes, 'key')

export default [...mergedUnAuth, ...mergedAuth]
export { mergedUnAuth as unAuthorizedRoutes }
export { mergedAuth as authorizedRoutes }
